var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    fillRule: "nonzero",
    d: "M10.673 7.333h-7.34c-.366 0-.666.3-.666.667 0 .367.3.667.666.667h7.34V9.86c0 .3.36.447.567.233l1.853-1.86a.341.341 0 000-.473L11.24 5.9c-.207-.213-.567-.06-.567.233v1.2z"
  }))));
}
export default SvgArrowRight;